
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ErrorMixin extends Vue {
  isDisplayErrorDialog = false;
  errorDialogTitle = "";
  errorDialogDescription = "";

  setErrorMessages(title: string, description: string) {
    this.errorDialogTitle = title;
    this.errorDialogDescription = description;
  }

  closeErrorDialog() {
    this.isDisplayErrorDialog = false;
    this.errorDialogTitle = "";
    this.errorDialogDescription = "";
  }
}
